'use client';

import { cn } from '@/utils/utils';
import { atom, useAtom, useSetAtom } from 'jotai';
import { forwardRef } from 'react';
import * as ResizablePrimitive from 'react-resizable-panels';

ResizablePrimitive.disableGlobalCursorStyles();

const isResizingAtom = atom(false);

export const useIsResizing = () => {
  const [isResizing, setIsResizing] = useAtom(isResizingAtom);
  return { isResizing, setIsResizing };
};

const ResizablePanelGroup = forwardRef<
  React.ElementRef<typeof ResizablePrimitive.PanelGroup>,
  React.ComponentPropsWithoutRef<typeof ResizablePrimitive.PanelGroup>
>(({ className, ...props }, ref) => {
  return (
    <ResizablePrimitive.PanelGroup
      ref={ref}
      className={cn(
        'flex h-full w-full data-[panel-group-direction=vertical]:flex-col',
        className,
      )}
      {...props}
    />
  );
});

ResizablePanelGroup.displayName = 'ResizablePanelGroup';

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
}) => {
  const setIsResizing = useSetAtom(isResizingAtom);
  return (
    <ResizablePrimitive.PanelResizeHandle
      className={cn(
        'relative flex w-px items-center cursor-col-resize [&[data-resize-handle-state="drag"]]:bg-blue  justify-center bg-borderSecondary after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90',
        className,
        'transition-transform duration-150 ease-in-out hover:scale-x-[3] active:scale-x-[3] [&[data-resize-handle-active]]:scale-x-[3]',
      )}
      {...props}
      onDragging={(e) => {
        props.onDragging?.(e);
        setIsResizing(e);
      }}
    >
      {/* {withHandle && (
        <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-elementGray3">
          <GripVertical className="h-2.5 w-2.5" />
        </div>
      )} */}
    </ResizablePrimitive.PanelResizeHandle>
  );
};

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
